





























import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";

const BASE_URL = "https://dev.apps.retailcreditcloudapi.net";

@Component
export default class Balance extends Vue {
  @Prop() private msg!: string;
  private error = "";
  private message = "";
  submit(e: any) {
    console.log(e.target.value);
    this.error = "";
    this.message = "";
    axios
      .post(
        `${BASE_URL}/api/giftcard/balance`,
        { data: e.target.value },
        {
          headers: {}
        }
      )
      .then(
        ({ data }: any) => {
          console.log(data);
          this.message = `You have a an available balance of ${data.balance}`;
        },
        error => {
          if (error.data.message === undefined)
            this.error = "Could not find account";
          else this.error = error.data.message;
          console.log(this.error, this.hasError());
          // this.error = "Could not find account";
        }
      )
      .catch(error => {
        this.error = "Could not find account";
      });
  }
  hasError() {
    return this.error.length > 0;
  }
  hasMessage() {
    return this.message.length > 0;
  }
}
